import { createSlice } from "@reduxjs/toolkit";

export const productSlice = createSlice({
  name: "productsReducer",
  initialState: {
    productDetails: {},
  },
  reducers: {
    setProductDetails: (state, action) => {
      state.productDetails = action.payload;
    },
  },
});

export const { setProductDetails } = productSlice.actions;
export default productSlice.reducer;
